import React, { useState, useEffect } from "react";
import ProfileCard from "./components/ProfileCard.js";
import "./App.css"; // Importa el archivo CSS

const App = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const handleLoad = () => setIsLoaded(true);
    window.addEventListener("load", handleLoad);

    // Set isLoaded to true immediately if the document is already loaded
    if (document.readyState === "complete") {
      setIsLoaded(true);
    }

    return () => {
      window.removeEventListener("load", handleLoad);
    };
  }, []);

  if (!isLoaded) {
    return <div className="loading-spinner">Cargando...</div>; // O muestra un spinner de carga si prefieres
  }

  return (
    <div className="app-container">
      <ProfileCard />
    </div>
  );
};

export default App;
